// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-DaVfl";
var _3 = "arrowBackText-2zAfA";
var _4 = "arrowBackIcon-Y2QAQ";
var _5 = "icon-2xHBS";
var _6 = "text-Izsc8";
var _7 = "both-24a6f";
export { _1 as "__esModule", _2 as "root", _3 as "arrowBackText", _4 as "arrowBackIcon", _5 as "icon", _6 as "text", _7 as "both" }
export default { "__esModule": _1, "root": _2, "arrowBackText": _3, "arrowBackIcon": _4, "icon": _5, "text": _6, "both": _7 }
